import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { PrimaryButton, LightButton, Forbidden } from '../../../components';

import styles from '../Modals.module.css';
import { roles } from '../../../types/types';

export const EliminarUsuarioModal = ({ hide, eliminar }) => {

  const { user } = useSelector(state => state.auth);

  return (user.rol === roles.MEDICO) ? (
    <div>
      <div className="row">
        <div className="col">
          <div className={styles.modalHeader}>Cancelar cuenta</div>
        </div>
      </div>
      <div className="row">
        <div className="col">
            <div className="row">
              <div className="col mt-3 mb-3">
                <p>Al cancelar la cuenta ya no será posible recuperar su información. ¿Desea continuar?</p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6">
                <LightButton
                  block={true}
                  icon="X"
                  marginTop={false}
                  onClick={ hide }
                  text="Cancelar"
                  type="button"
                />
              </div>
              <div className='col-xs-12 col-sm-12 col-md-6'>
                <PrimaryButton
                  block={true}
                  icon="Check"
                  marginTop={false}
                  onClick={ eliminar }
                  text="Continuar"
                  type="button"
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  ) : <Forbidden />
}

EliminarUsuarioModal.propTypes = {
  hide: PropTypes.func.isRequired,
  eliminar: PropTypes.func.isRequired,
}